import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  FaGlobe,
  FaLaptopCode,
  FaShieldAlt,
  FaThumbsUp,
  FaUniversalAccess,
  FaLightbulb,
  FaChartLine,
  FaAward,
} from "react-icons/fa";

const ICONS = [
  FaGlobe,
  FaLaptopCode,
  FaShieldAlt,
  FaThumbsUp,
  FaUniversalAccess,
  FaLightbulb,
  FaChartLine,
  FaAward,
];

export const WhyChooseUs = () => {
  const { t } = useTranslation("landing");
  const items = t("whyChooseUs.items", { returnObjects: true });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: 0 }
    );

    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="why-choose-us">
      <h2 className="title reveal">
        {t("whyChooseUs.title")}{" "}
        <span>{t("whyChooseUs.titleHighlight")}</span>
      </h2>

      <div className="why-cards-container">
        {Array.isArray(items) &&
          items.map((title, index) => {
            const Icon = ICONS[index] || FaGlobe;
            return (
              <div key={index} className="why-card reveal">
                <div className="why-icon">
                  <Icon />
                </div>
                <p className="why-title">{title}</p>
              </div>
            );
          })}
      </div>
    </section>
  );
};
